export default __webpack_public_path__ + "static/bg-b2d27abfa8c02de9c942c01fbb9efbc7.jpg";